define([], ()=> {
    /**
     * Module that returns the current date. Can be replaced with
     * another implementation, for example if you needed to time travel and return
     * a different current date
     */
    return {
        currentDate: ()=> {
            return new Date();
        },
        getYear: (date)=> {
            return date ? date.getFullYear() : null;
        },

        /**
         * Returns new date object with time portion set to zero
         * Original date parameter is not modified
         * @param date Initial date. Tis object is not modified
         * @returns {Date}
         */
        trimToMidnight: (date)=> {
            const returnedDate = new Date(date);
            returnedDate.setHours(0, 0, 0, 0);
            return returnedDate;
        },

        getHour: (date)=> {
            return date.getHours();
        },

        /**
         * Increments date by x number of hours
         *
         * @param date Initial date. Tis object is not modified
         * @param hrsToAdd (Integer} number of hours to add
         * @returns {Date} new date object incremented by 4 hours
         */
        addHours: (date, hrsToAdd)=> {
            date.setHours(date.getHours() + hrsToAdd);
            return date;
        },

        /**
         * Returns the current time with minutes, seconds and milliseconds set to zero
         * @returns {*}
         */
        getCurrentTimeTrimmedToHour() {
            const time = this.currentDate();
            time.setMinutes(0, 0, 0);
            return time;
        },

        /**
         * Compares the dates of two Date objects minus dates.
         * @param date1 First date to check.
         * @param date2 Second date to check.
         * @returns {Number} -1 if date1 is before date2, 0 if they are equal, 1 if date2 is after date1.
         */
        compareIgnoreTime: (date1, date2) => {
            const date1NoTime = new Date(date1).setHours(0, 0, 0, 0);
            const date2NoTime = new Date(date2).setHours(0, 0, 0, 0);

            if (date1NoTime > date2NoTime) {
                return 1;
            }
            if (date1NoTime < date2NoTime) {
                return -1;
            }
            return 0;

        }
    };
});



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/util/DateUtil.js